/*
 * types/services/dr2am.tasks.permissions.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbPermissionRole} from './PbPermissionRole';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceCreatePermissionsResponse model module.
 * @module model/ServiceCreatePermissionsResponse
 * @version version not set
 */
export class ServiceCreatePermissionsResponse {
  /**
   * Constructs a new <code>ServiceCreatePermissionsResponse</code>.
   * @alias module:model/ServiceCreatePermissionsResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceCreatePermissionsResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceCreatePermissionsResponse} obj Optional instance to populate.
   * @return {module:model/ServiceCreatePermissionsResponse} The populated <code>ServiceCreatePermissionsResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceCreatePermissionsResponse();
      if (data.hasOwnProperty('permission'))
        obj.permission = PbPermissionRole.constructFromObject(data['permission']);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbPermissionRole} permission
 */
ServiceCreatePermissionsResponse.prototype.permission = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceCreatePermissionsResponse.prototype.state = undefined;


